import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import './About.css';

export function About() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <header className="page-header">
        <div className="container flex justify-between items-center">
          <a href="/" className="logo">
            <img src="/logo-header.png" alt="SolarMaktab" className="logo-img" />
          </a>
          <div className="header-actions">
            <LanguageSwitcher />
            <a href="/login" className="btn btn-outline btn-sm">{t('common.login')}</a>
          </div>
        </div>
      </header>

      <main className="about-content">
        <div className="container">
          <div className="about-hero">
            <span className="badge mb-md">{t('about.badge', 'About Us')}</span>
            <h1>{t('about.title', 'Our Mission')}</h1>
            <p className="about-subtitle">
              {t('about.subtitle', 'Bringing quality education to every corner of the world, with or without internet.')}
            </p>
          </div>

          <div className="about-placeholder">
            <div className="placeholder-icon">🏗️</div>
            <h2>{t('about.comingSoon', 'Content Coming Soon')}</h2>
            <p>{t('about.comingSoonText', 'We are working on sharing our story with you. Check back soon!')}</p>
          </div>

          <div className="about-actions">
            <button className="btn btn-primary" onClick={() => navigate('/')}>
              {t('common.back', 'Back to Home')}
            </button>
            <button className="btn btn-outline" onClick={() => navigate('/contact')}>
              {t('footer.contact', 'Contact Us')}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
